import React, { PropTypes } from 'react';
import AddItemCard from '../../generic-components/add-item-card/add-item-card';

const AddProductButton = ({ openAddEditContractDialog }) => {
  return (
    <div style={{ margin: '8px 0 16px 16px' }}>
      <AddItemCard
        text={`Add room types/products`}
        onClick={() => openAddEditContractDialog({
          type: 'addProducts',
        })}
        editable
      />
    </div>);
};

AddProductButton.propTypes = {
  openAddEditContractDialog: PropTypes.func,
};

export default AddProductButton;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/add-product-button.jsx